// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.reportsummary[data-v-26235fac] {\n    margin: 0 0 10px;\n    color: #555;\n    font-style: italic;\n}\n.table tbody tr[data-v-26235fac] {\n    cursor: pointer;\n}\n@media print {\n.reportsummary[data-v-26235fac] {\n        text-align: center;\n}\n}\n", ""]);
// Exports
module.exports = exports;
